import * as React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const salmonBase = "#FF5733";
const violetBase = "#7F00FF";
const antiqueGold = "#7a6f29";

export function MUIThemeProvider({ children }) {
  let theme = createTheme({});
  // theme = createTheme({
  //   colorSchemes: {
  //     light: {
  //       palette: {
  //         primary: theme.palette.augmentColor({
  //           name: "primary",
  //           color: {
  //             main: salmonBase,
  //           },
  //         }),
  //       },
  //       components: {
  //         MuiAutocomplete: {
  //           styleOverrides: {
  //             popper: {
  //               zIndex: 1300,
  //             },
  //           },
  //         },
  //       },
  //     },
  //     dark: {
  //       palette: {
  //         primary: theme.palette.augmentColor({
  //           name: "primary",
  //           color: {
  //             main: antiqueGold,
  //           },
  //         }),
  //         background: {
  //           default: "#0d1f1a", // Deep green-black
  //           paper: "#123229", // Muted forest green
  //         },
  //       },
  //       components: {
  //         MuiCssBaseline: {
  //           styleOverrides: {
  //             body: {
  //               background: `linear-gradient(135deg, #0f1a13, ${antiqueGold}, #bfa437)`,
  //             },
  //           },
  //         },
  //         MuiAutocomplete: {
  //           styleOverrides: {
  //             popper: {
  //               zIndex: 1300,
  //             },
  //           },
  //         },
  //       },
  //     },
  //   },
  // });
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
